module.exports = require('./helpers/bundle-url').getBundleURL('glOsZ') + "gridmarket-logo.206016d1.svg";